// extracted by mini-css-extract-plugin
export default {"imageWrapper":"yK-z","twoColumnImage":"zK-z"};